export default __webpack_public_path__ + "static/media/process2.f6a35952.PNG";